<template>
  <div>
    <div class="show-right">
      <div class="main-content left" style="margin-top: 20px;margin-left: 30px;">
        <div>
          <el-button v-if="readonly" type="primary" no="1" @click="edit()"> {{ $t('common.btn.edit') }} </el-button>
          <el-button v-if="!readonly" type="primary" no="2" @click="cancel()"> {{ $t('common.btn.cancel') }} </el-button>
          <el-button v-if="!readonly" type="primary" no="3" style="margin-left: 5px;" @click="saveOcrTemplate()"> {{ $t('common.btn.save') }} </el-button>
        </div>
        <div style="width: 100%;">
          <el-form style="margin-top: 20px" :disabled="readonly" label-position="right" label-width="140px">
            <el-form-item :label="$t('CargoMsg.Cargo_TemplateIdAutomaticallyGenerated')">
              {{ ocrTemplate.uuid }}
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_TemplateStatus')">
              <el-radio-group v-model="ocrTemplate.active">
                <el-radio :label="true">{{ $t('CargoMsg.Cargo_Valid') }}</el-radio>
                <el-radio :label="false">{{ $t('CargoMsg.Cargo_Invalid2') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_IdentifyTemplateName2')">
              <el-input v-model="ocrTemplate.templateName" no="templateName" style="width: 580px;" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_DocumentTypeDescription2')">
              <el-input v-model="ocrTemplate.fileTypeDescription" :filter-chars="false" no="fileTypeDescription" type="textarea" :rows="17" style="height: 300px;width: 580px" maxlength="2000" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_OutputRequirements')" style="margin-top: 15px">
              <el-input v-model="ocrTemplate.outputRequirements" :filter-chars="false" no="outputRequirements" type="textarea" :rows="17" style="height: 300px;width: 580px" maxlength="2000" />
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="division" style="margin-left: 50px;">
        &nbsp;
      </div>
      <div class="right">
        <div style="margin-top: 20px;margin-left: 30px;">
          <div>
            <span style="font-size: 18px">{{ $t('CargoMsg.Cargo_ReadField') }}</span>
            <el-button type="primary" no="view" style="margin-left: 10px;" @click="lookTemplateField()"> {{ $t('CargoMsg.Cargo_View') }} </el-button>
            <el-button type="primary" :disabled="ocrTemplateFieldDisabled" no="4" style="margin-left: 10px;" @click="addTemplateField()"> {{ $t('SeaExport.Add') }} </el-button>
            <el-button type="primary" :disabled="ocrTemplateFieldDisabled" no="5" style="margin-left: 5px;" @click="editTemplateField()"> {{ $t('SeaExport.Edit') }} </el-button>
            <el-button type="danger" :disabled="ocrTemplateFieldDisabled" no="6" style="margin-left: 5px;" @click="deleteTemplateField()"> {{ $t('SeaExport.Delete') }} </el-button>
          </div>
          <div style="width: 600px;margin-top: 30px;">
            <cargo-ag-grid
              :show-side-bar="false"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="rowData"
              style="width:100%;height:400px;margin-top: 10px;"
              @gridReady="params=>{gridApi=params.api}"
            />
          </div>
        </div>
      </div>
    </div>
    <div>
      <div style="display: inline-block">
        <el-button type="primary" no="7" style="margin-left: 670px;" @click="previewPromptWord()"> {{ $t('CargoMsg.Cargo_PreviewPromptWords') }} </el-button>
      </div>
      <div style="display: inline-block">
        <el-button type="primary" no="8" style="margin-left: 60px;" @click="goBack()"> {{ $t('CargoMsg.Cargo_Back') }} </el-button>
      </div>
    </div>
    <!-- ocr字段弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="ocrTemplateFieldDialog.visible"
      :title="ocrTemplateFieldDialog.title"
      width="700px"
      height="950px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="110px" label-position="left">
          <el-form-item :label="$t('CargoMsg.Cargo_FieldName')">
            <el-input v-model="ocrTemplateFieldDialog.form.fieldName" :disabled="ocrTemplateFieldDialog.look" no="fieldName" style="width: 540px;" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_FieldRuleDescription')">
            <el-input v-model="ocrTemplateFieldDialog.form.fieldRuleDescription" :disabled="ocrTemplateFieldDialog.look" :filter-chars="false" no="fieldRuleDescription" type="textarea" :rows="21" style="width: 540px;" maxlength="2000" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button v-show="!ocrTemplateFieldDialog.look" type="primary" no="7" :disabled="ocrTemplateFieldDialog.look" @click="saveOcrTemplateField">{{ $t('common.btn.save') }}</el-button>
        <el-button v-show="!ocrTemplateFieldDialog.look" no="8" @click="ocrTemplateFieldDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
        <el-button v-show="ocrTemplateFieldDialog.look" no="8" @click="ocrTemplateFieldDialog.visible=false">{{ $t('CargoMsg.Cargo_Back') }}</el-button>
      </span>
    </el-dialog>
    <!-- 预览提示词 弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="promptWordDialog.visible"
      :title="$t('CargoMsg.Cargo_PreviewPromptWords')"
      width="700px"
      :close-on-click-modal="true"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form style="margin-left: 50px">
          <el-form-item>
            <pre style="white-space: pre-wrap;overflow-y: auto;overflow-x: hidden;width: 600px;height:60vh;min-height: 300px;" v-html="promptWordDialog.promptWord" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="promptWordDialog.visible=false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import { deepCopy } from '@/utils/commonUtil'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import {
  deleteOcrTemplateField,
  getOcrTemplateFieldList, getOcrTemplatePromptWord,
  saveOcrTemplate,
  saveOcrTemplateField
} from '@/api/ocrTemplate'
import ColumnUtils from '@/utils/ColumnUtils'
import * as SystemConstant from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'OcrTemplateConfigDetail',
  props: {
    ocrTemplate: { type: Object, default: () => {} },
    initialAction: { type: String, required: false, default: 'look' },
    visible: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      action: 'look',
      originOcrTemplate: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowClicked: event => { this.selectedRow = event.data }
      },
      rowData: [],
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_Sequence'),
          field: 'serialNumber',
          width: 25,
          sortable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FieldName'),
          field: 'fieldName',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_FieldRuleDescription'),
          field: 'fieldRuleDescription',
          width: 200
        }
      ],
      gridApi: null,
      selectedRow: null,
      ocrTemplateFieldDialog: {
        visible: false,
        title: '',
        look: false,
        form: {
          uuid: '',
          tenantId: '',
          type: '',
          oldText: '',
          newText: ''
        }
      },
      promptWordDialog: {
        visible: false,
        promptWord: null
      },
      loading: null
    }
  },
  computed: {
    readonly() {
      return this.action === 'look'
    },
    ocrTemplateFieldDisabled() {
      return !this.ocrTemplate || !this.ocrTemplate.uuid || this.readonly
    }
  },
  created() {
    this.originOcrTemplate = deepCopy(this.ocrTemplate)
    this.initOcrTemplateField()
    if (this.initialAction === 'edit') {
      this.edit()
    }
  },
  methods: {
    edit() {
      // 模板生效且被租户绑定时，不可【编辑】、不可【代码处理】
      if (SystemConstant.OCR_TEMPLATE_STATUS_VALID.code === this.ocrTemplate.active && this.ocrTemplate.used) {
        this.$message.warning(this.$t('CargoMsg.Cargo_TemplateUsed'))
        return
      }
      this.action = 'edit'
    },
    cancel() {
      this.action = 'look'
      this.$emit('ocrTemplateSave', deepCopy(this.originOcrTemplate))
    },
    // 最终保存
    saveOcrTemplate() {
      if (!this.ocrTemplate.templateName) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('CargoMsg.Cargo_IdentifyTemplateName'))
        return
      }
      this.loading = getLoading4Cxt()
      saveOcrTemplate(this.ocrTemplate).then(res => {
        this.action = 'look'
        this.$message.success(this.$t('common.tips.saveSuccess'))
        this.$emit('ocrTemplateSave', res.data)
        this.originOcrTemplate = deepCopy(res.data)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 查看
    lookTemplateField() {
      if (!this.selectedRow) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectSpecificFields'))
        return
      }
      this.ocrTemplateFieldDialog.title = this.$t('CargoMsg.Cargo_FieldView')
      this.ocrTemplateFieldDialog.form = this.selectedRow
      this.ocrTemplateFieldDialog.look = true
      this.ocrTemplateFieldDialog.visible = true
    },
    // 新增
    addTemplateField() {
      this.ocrTemplateFieldDialog.title = this.$t('CargoMsg.Cargo_FieldAdd')
      this.ocrTemplateFieldDialog.look = false
      this.ocrTemplateFieldDialog.form = {
        ocrTemplateUuid: this.ocrTemplate.uuid
      }
      this.ocrTemplateFieldDialog.visible = true
    },
    // 编辑
    editTemplateField() {
      if (!this.selectedRow) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectSpecificFields'))
        return
      }
      this.ocrTemplateFieldDialog.title = this.$t('CargoMsg.Cargo_FieldEdit')
      this.ocrTemplateFieldDialog.form = this.selectedRow
      this.ocrTemplateFieldDialog.look = false
      this.ocrTemplateFieldDialog.visible = true
    },
    // 删除
    deleteTemplateField() {
      if (!this.selectedRow || !this.selectedRow.uuid) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseSelectOneEntry'))
        return
      }
      const self = this
      self.$confirm(this.$t('CargoMsg.Cargo_ConfirmToDeleteThisField'), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        self.loading = getLoading4Cxt()
        deleteOcrTemplateField(self.selectedRow).then(res => {
          if (res.data > 0) {
            self.$message.success(self.$t('common.tips.deleteSuccess'))
            self.initOcrTemplateField()
          } else {
            self.$message.error(self.$t('Message.DeleteFailed'))
          }
        }).finally(() => {
          self.loading.close()
        })
      }).catch(() => {
      })
    },
    // 保存字段
    saveOcrTemplateField() {
      if (!this.ocrTemplateFieldDialog.form.fieldName) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('CargoMsg.Cargo_FieldName'))
        return
      }
      this.loading = getLoading4Cxt()
      saveOcrTemplateField(this.ocrTemplateFieldDialog.form).then(res => {
        this.$message.success(this.$t('common.tips.saveSuccess'))
        this.ocrTemplateFieldDialog.visible = false
        this.initOcrTemplateField()
      }).finally(() => {
        this.loading.close()
      })
    },
    initOcrTemplateField() {
      if (this.ocrTemplate.uuid) {
        this.loading = getLoading4Cxt()
        const params = {
          ocrTemplateUuid: this.ocrTemplate.uuid
        }
        getOcrTemplateFieldList(params).then(res => {
          this.rowData = res.data || []
          ColumnUtils.addSerialNumber(this.rowData)
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    previewPromptWord() {
      if (this.ocrTemplate.uuid) {
        this.loading = getLoading4Cxt()
        const params = {
          ocrTemplateUuid: this.ocrTemplate.uuid
        }
        getOcrTemplatePromptWord(params).then(res => {
          this.promptWordDialog.promptWord = res.data
        }).finally(() => {
          this.loading.close()
        })
      }
      this.promptWordDialog.visible = true
    },
    goBack() {
      this.$emit('goBack')
    }
  }
}
</script>
<style scoped lang="scss">
.show-right {
  background-color: #FFFFFF;
  display: block;
  float: left;
  width: 100%;
  min-width: 2000px;
  margin-top: 5px;
  height: 900px;
  .left {
    min-width: 700px;
    display: block;
    float: left;
    width: 700px;
  }
  .division {
    background-color: #2d2f33;
    display: table;
    float: left;
    width: 1px;
    margin-top: 10px;
    margin-bottom: 10px;
    height: 95%;
  }
  .right {
    display: block;
    float: left;
    width: calc(30% - 6px);
    min-width: 450px;
  }
}
</style>
